
























import { Component, Vue } from 'vue-property-decorator'
import Nav from '@/components/navbar/index.vue'
import Encryption from '@/views/tool/component/Encryption.vue'
import Rent from '@/views/tool/component/Rent.vue'
import Timestamp from '@/views/tool/component/Timestamp.vue'
import Invest from '@/views/tool/component/Invest.vue'

@Component({
  name: 'Tool',
  components: {
    Nav,
    Encryption,
    Rent,
    Timestamp,
    Invest
  }
})
export default class extends Vue {
  private activeIndex = '1'
  private showKey = '1'

  private handleSelect (key: string) {
    this.showKey = key
  }
}
